var map = {
	"./android.png": 1500,
	"./css.png": 1516,
	"./git.png": 1912,
	"./html5.png": 3504,
	"./jquery.png": 1556,
	"./js.png": 4296,
	"./laravel.png": 6696,
	"./php.png": 3728,
	"./sass.png": 396,
	"./sql.png": 4192,
	"./vue.png": 8528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7644;